import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";

export const ResaleListingsContext = createContext();

export const useResaleListingsContext = () => useContext(ResaleListingsContext);

export const ResaleListingsProvider = ({ children, ...props }) => {
  const [listableTickets, setListableTickets] = useState(props.listableTickets || []);
  const [selectedTicketIds, setSelectedTicketIds] = useState([]);
  const [listPriceCents, setListPriceCents] = useState(null);
  const [agreedAttestations, setAgreedAttestations] = useState([]);
  const [step, setStep] = useState(1);
  // Populated only after the single-shot create returns the now-active listing.
  const [createdListing, setCreatedListing] = useState(null);

  const value = {
    ...props,
    listableTickets,
    setListableTickets,
    selectedTicketIds,
    setSelectedTicketIds,
    listPriceCents,
    setListPriceCents,
    agreedAttestations,
    setAgreedAttestations,
    step,
    setStep,
    createdListing,
    setCreatedListing,
  };

  return (
    <ResaleListingsContext.Provider value={value}>
      {children}
    </ResaleListingsContext.Provider>
  );
};

ResaleListingsProvider.propTypes = {
  children: PropTypes.node.isRequired,
  orderId: PropTypes.number,
  calendarEvent: PropTypes.object,
  listableTickets: PropTypes.arrayOf(PropTypes.object),
  myListingsPath: PropTypes.string,
  payoutSetupPending: PropTypes.bool,
  resalePriceCapPercentage: PropTypes.number,
  resaleClosesAt: PropTypes.string,
  payableSellerStates: PropTypes.arrayOf(PropTypes.string),
  opendateSellerServiceFeePercentage: PropTypes.number,
  organizerSellerServiceFeePercentage: PropTypes.number,
  opendateSellerServiceFeeFlatCents: PropTypes.number,
  organizerSellerServiceFeeFlatCents: PropTypes.number,
  absorbedBuyerFeeRates: PropTypes.object,
  sellerAttestations: PropTypes.arrayOf(PropTypes.string),
  sellerAttestationVersion: PropTypes.string,
};

ResaleListingsProvider.defaultProps = {
  resalePriceCapPercentage: null,
  resaleClosesAt: null,
  payableSellerStates: [],
  absorbedBuyerFeeRates: null,
};
